import { render } from "./CopyIcon.vue?vue&type=template&id=a0677a0e&scoped=true"
const script = {}

import "./CopyIcon.vue?vue&type=style&index=0&id=a0677a0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0677a0e"]])

export default __exports__